export const SUMMIT_EVENT_DATE = new Date('2026-03-25T00:00:00-03:00')

export const shouldShowSummit = () => {
	if (process.env.NODE_ENV !== 'production') return false
	return new Date() < SUMMIT_EVENT_DATE
}
